import { createSlice } from '@reduxjs/toolkit';
import { buildAsyncReducers } from '../thunkTemplate';
import { management as initialState } from '../initialState';

import { authenticateManagementUser, getManagementOrganizations, getManagementUsers } from './_management';

const { reducer } = createSlice({
  name: 'management',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [authenticateManagementUser, getManagementOrganizations, getManagementUsers]);
  },
});

export { authenticateManagementUser, getManagementOrganizations, getManagementUsers };
export default reducer;
